<template>
    <div  style=" max-width: 100vw; overflow: hidden;">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css" />
        <Navbar />
        <section id="section-banner-clientes" class="clientesImg">
            <div class="container">
                <div class="row d-flex justify-content-center">
                    <div class="col-9 text-center ajuste-textos animate__animated animate__fadeInLeft">
                        <h1 class="textos subtitulos-principales blanco bold">CLIENTES</h1>
                        <p class="textos subtitulos-intermedios-sec-ajustes light blanco pb-md-3">Organizaciones que nos han brindado la confianza y han puesto su tranquilidad en nuestras manos.</p>
                    </div>
                </div>
            </div>
        </section>
        <section id="flechas-generales">
            <div class="flecha-down wow animate__animated animate__fadeInDown animate__infinite	infinite animate__slow">
                <img src="../assets/home/flecha-abajo.png" alt="" />
            </div>
        </section>
        <div>
            <section>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12 col-md-6 fondo-forma formImg1"></div>
                        <div class="col-12 col-md-6 py-5">
                            <div class="row d-flex justify-content-center">
                                <div class="col-6 col-md-4 text-center icons-clientes">
                                    <img src="../assets/template/clientes/1.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-4 text-center icons-clientes">
                                    <img src="../assets/template/clientes/21.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-4 text-center icons-clientes">
                                    <img src="../assets/template/clientes/7.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-4 text-center icons-clientes">
                                    <img src="../assets/template/clientes/23.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-4 text-center icons-clientes">
                                    <img src="../assets/template/clientes/14.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-4 text-center icons-clientes">
                                    <img src="../assets/template/clientes/5.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-4 text-center icons-clientes">
                                    <img src="../assets/template/clientes/15.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-4 text-center icons-clientes">
                                    <img src="../assets/template/clientes/22.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-4 text-center icons-clientes">
                                    <img src="../assets/template/clientes/2.png" alt="" class="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 py-md-5 order-2 order-md-1">
                            <div class="row py-md-4 d-flex justify-content-center">
                                <div class="col-6 col-md-3 text-center icons-clientes">
                                    <img src="../assets/template/clientes/24.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-3 text-center icons-clientes">
                                    <img src="../assets/template/clientes/18.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-3 text-center icons-clientes">
                                    <img src="../assets/template/clientes/17.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-3 text-center icons-clientes">
                                    <img src="../assets/template/clientes/12.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-4 text-center icons-clientes">
                                    <img src="../assets/template/clientes/11.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-4 text-center icons-clientes">
                                    <img src="../assets/template/clientes/20.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-4 text-center icons-clientes">
                                    <img src="../assets/template/clientes/10.png" alt="" class="img-fluid" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 fondo-forma-dos order-1 order-md-2  py-5 formImg2"></div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 fondo-forma-tres formImg3"></div>
                        <div class="col-md-6 py-md-5  py-5">
                            <div class="row py-md-4 d-flex justify-content-center">
                                <div class="col-6 col-md-3 text-center icons-clientes">
                                    <img src="../assets/template/clientes/4.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-3 text-center icons-clientes">
                                    <img src="../assets/template/clientes/13.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-3 text-center icons-clientes">
                                    <img src="../assets/template/clientes/6.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-3 text-center icons-clientes">
                                    <img src="../assets/template/clientes/25.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-4 text-center icons-clientes">
                                    <img src="../assets/template/clientes/16.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-4 text-center icons-clientes">
                                    <img src="../assets/template/clientes/19.png" alt="" class="img-fluid" />
                                </div>
                                <div class="col-6 col-md-4 text-center icons-clientes">
                                    <img src="../assets/template/clientes/8.png" alt="" class="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
        <Footer />
    </div>
</template>
<style>
  
  
    @import "../assets/template/css/HomaMedia.css";
    @import "../assets/template/css/textosF.css";
    @import "../assets/template/css/generals.css";
    @import "../assets/template/css/ContenidoServices.css";

    .clientesImg {
        background-image: url("../assets/clientes/bannerCli.png");
        background-position: 50%;
        background-size: cover;
        background-repeat: no-repeat;
        min-height: 650px;
    }

    .formImg1 {
        background-image: url("../assets/clientes/forma-1.png");
    }

    .formImg2 {
        background-image: url("../assets/clientes/forma-4.png");
    }

    .formImg3 {
        background-image: url("../assets/clientes/forma-3.png");
    }

    #section-banner-clientes {
        min-height: 650px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(../assets/clientes/bannerCli.png);
    }

        #section-banner-clientes .ajuste-textos {
            padding-top: 180px;
        }

    @media (max-width: 540px) {
        #section-banner-clientes {
            min-height: 550px;
        }

        .formImg1 {
            height: 250px !important;
        }
        .formImg2 {
            height: 250px !important;
        }
        .formImg3 {
            height: 250px !important;
        }
    }
    
    
</style>



<script>

    import Navbar from './shared/Navbar/Navbar.vue';
    import Footer from './shared/footer/Footer.vue';

    export default {
        name: 'MyComponent',
        components: {
            
            Navbar,
            Footer
        },
        data() {
            
            return {
                

            };
        },
        computed: {


        },
        methods: {



        },
        mounted() {
            window.scrollTo({ top: 0, behavior: 'smooth' });

        },
    };
</script>
